export default __webpack_public_path__ + "static/media/startag.cb1ee2ab.svg";